import { useParams } from "react-router-dom";
import useAuth from "../../../../hooks/useAuth";
import MobileForm from "../../../../components/MobileForm";

const CASInterim = () => {
  const { version } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  return (
    <div>
      <MobileForm
        type="casInterim"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
    </div>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();

  return (
    <PrivateContent title="CAS Interim">
      <CASInterim />
    </PrivateContent>
  );
};

export default Page;